// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__onBRd","label":"SetPasswdForm_label__z0WBv"};